import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import VoyagerSearchBarBlockView from './VoyagerSearchBarBlock';
import VoyagerSearchBarBlockSchema from './VoyagerSearchBarBlockSchema';

type VoyagerSearchBarBlockEditProps = React.ComponentProps<
  typeof VoyagerSearchBarBlockView
> & {
  block: string;
  selected?: boolean;
  onChangeBlock: (block: string, data: Record<string, unknown>) => void;
};

const VoyagerSearchBarBlockEdit: React.FC<VoyagerSearchBarBlockEditProps> = (
  props,
) => {
  const { data, block, onChangeBlock, selected } = props;

  return (
    <>
      <VoyagerSearchBarBlockView {...props} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={VoyagerSearchBarBlockSchema}
          title={VoyagerSearchBarBlockSchema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, {
              ...(data || {}),
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default VoyagerSearchBarBlockEdit;
